import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsThemeSMSUpdate = (isAdmin = false) => {
  return dispatch => { 
    APIPost(UrlServer.URL_POST_THEME_SMS_GET,{isAdmin:isAdmin}, datas => {
      dispatch({ type: actionTypes.LISTS_THEME_SMS, listsThemeSMS: datas.datas })
    })
  }
}
